import React from "react"

import Featured from "./featured/Featured"
import Hero from "./hero/Hero"


import Recent from "./recent/Recent"


const Home = () => {
  return (
    <>
      <Hero />
      <Featured />
      <Recent />
      
    </>
  )
}

export default Home
